/**
 * @file ServerNotifications.jsx
 * @description client-side notifications received 
 *              from the server via azure.pubSub
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 * 
 * @author don michael
 * @since Feb 16, 2026 @ 01:54 PM
 */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { usePubSub } from 'src/services/ServerPubSub/usePubSub.jsx';

import { objectDeepCopy, objectHas } from 'src/@common/utilities';
import { copyObject } from 'src/@common/objectCopyUtils';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

const ServerNotifications = () => {
    const dispatch = useDispatch();

    const { messageObj } = usePubSub();

    // effect executed whenever new data is received
    useEffect(() => {

        // base options
        const baseOptions = {
            autoHideDuration: 5000,
            anchorOrigin: {
                vertical: 'bottom', // top bottom
                horizontal: 'right', // left center right
            },
            variant: 'success',
            preventDuplicate: true,
            style: {
                color: 'white',
                fontFamily: 'Arial',
                fontSize: 18,
            },
            persist: false,
            data: {
                action: 'none',
            }
        }

        // process only when messageObjis not null
        if (messageObj) {

            if (messageObj.type === 'notification') {

                if (objectHas(messageObj, 'options')) {
                    copyObject(messageObj.params.options, baseOptions);
                }

                let params = {};
                if (objectHas(messageObj, 'params')) {
                    params = objectDeepCopy(messageObj.params);
                }

                dispatch(enqueueMessage(messageObj.message, baseOptions, params));
            }
        }
    }, [messageObj, dispatch]);

    return (null
        // <div className="notification-system">
        //     <div className="connection-status">
        //         {error && <div className="error-message">⚠️ {error}</div>}
        //     </div>
        // </div>
    );
};

export default ServerNotifications;